import { atom } from 'jotai';
import type { ControlBarInsightsState } from './ControlBarInsightsButton';

export const isAddOrShareMenuOpenAtom = atom(false);
export const controlBarInsightsStateAtom = atom<ControlBarInsightsState>({
  isOpen: false,
});
